<div *ngIf="showBanner && !currentRoute.includes('/tareo/lista')" class="items-center space-x-6 justify-center bg-mg-red-dark text-white overflow-hidden px-6 py-1 sm:text-sm w-full h-[45px] border-b-2 border-white">
  <div class="flex flex-wrap text-center justify-center items-center h-full">
      <div class="flex cursor-pointer text-lg" (click)="goToTareo()">
        Tiene una revisión en curso.   
        &nbsp; <mg-icon iconName="open_in_new" iconClass="text-white text-lg"> </mg-icon>
      </div>
  </div>
</div>
<!-- 
(mouseenter)="hidden()" -->